import { useEffect } from 'react';

const PdfLibLoader = () => {
  useEffect(() => {
    if (window.pdfjsLib) {
      return;
    }

    const script = document.createElement('script');
    script.async = false;
    script.src = '/pdfjs-3.11.174/pdf.js';
    script.type = 'text/javascript';
    script.onload = () => {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdfjs-3.11.174/pdf.worker.js';
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default PdfLibLoader;
